import { PopupInner } from '@shared/layouts/popup-inner/popup-inner'

import { useMount } from '@shared/hooks/screen'

type AnimationType = 'center' | 'right'

type PopupProps = {
  children: React.ReactNode
  withClose?: boolean
  onClose: () => void
  isOpened: boolean
  withOverlay?: boolean
  animationType?: AnimationType
  contentCls?: string
}

export const Popup = ({
  children,
  withClose = true,
  onClose,
  isOpened,
  withOverlay,
  animationType = 'center',
  contentCls
}: PopupProps) => {
  const { mounted } = useMount({ opened: isOpened })
  if (!mounted) {
    return null
  }

  return (
    <PopupInner
      onClose={onClose}
      withClose={withClose}
      opened={isOpened}
      withOverlay={withOverlay}
      animationType={animationType}
      contentCls={contentCls}
    >
      {children}
    </PopupInner>
  )
}
